import styled from 'styled-components';

export const StyledAssetFilterContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: ${({ theme }) => theme.space[16]};
`;
